import React from 'react';

import ReactDOM from 'react-dom/client';
import { 
  BrowserRouter, 
} from "react-router-dom";

import './index.css';
import App from './App';
import { AppProvider } from './contextProviders/AppProvider';
import { AuthProvider } from './contextProviders/AuthProvider';
import { DataProvider } from './contextProviders/DataProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <AppProvider>
          <DataProvider>
            <App />
          </DataProvider>
        </AppProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
